import { Logger } from '@hawtiosrc/core/logging'

export const pluginId = 'consolestatus'
export const pluginTitle = 'Console Status'
export const pluginPath = '/consolestatus'
export const pluginName = 'hawtio-consolestatus'
export const log = Logger.get(pluginName)
